import { ApiCore } from './utilities/core'

export const registerApi = new ApiCore({
  post: true,
  url: 'api/register'
})
